"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionDetails = void 0;
require("./transaction-details.less");
const material_ui_1 = require("material-ui");
const errors_1 = require("shared/erx/errors");
const mobx_react_1 = require("mobx-react");
const store_1 = require("client/modules/orders/store");
const mobx_1 = require("mobx");
const _1 = require(".");
const React = require("react");
const ReactTooltip = require("react-tooltip");
const moment = require("moment-timezone"); //B-096.2
const erxDelimiterMap = {
    "A": "1",
    "B": "2",
    "C": "3",
    "D": "4",
    "E": "5",
    "F": "6",
    "G": "7",
    "H": "8",
    "I": "9",
    "{": "0"
};
let TransactionDetails = class TransactionDetails extends React.Component {
    constructor(props) {
        super(props);
        // {erxReq[i]?.date}  C-127
        this.mapRequests = (site, // C-127.2
        requests, tag) => {
            var _a;
            const { erxLog } = this.props;
            let erxReq = (_a = (erxLog || [])) === null || _a === void 0 ? void 0 : _a.filter((item) => item.outgoing === 1); //B-096.2
            const content = (requests !== null && requests !== void 0 ? requests : []).map((request, i) => {
                var _a, _b;
                return (React.createElement("div", { key: `req-${tag}-${i}`, className: "transaction-details__body--container" },
                    React.createElement("h2", null,
                        tag === "copay" && "Copay ",
                        "Transaction #",
                        i + 1),
                    React.createElement("div", { className: "transaction-details__body--nested-list" },
                        erxLog && (React.createElement("div", { style: { display: "ruby-text" } },
                            React.createElement("span", null,
                                React.createElement("h4", null, "Date & Time")),
                            " ",
                            ((_a = erxReq[i]) === null || _a === void 0 ? void 0 : _a.date) ? (React.createElement("span", null, moment.tz((_b = erxReq[i]) === null || _b === void 0 ? void 0 : _b.date, site.timezone).format("MM/DD/YYYY hh:mm:ss A z"))) : (""))),
                        this.recursiveMap(request))));
            });
            return content;
        };
        // {erxReq[i]?.date}  C-127
        this.mapResponses = (site, // C-127.2
        responses, tag) => {
            var _a;
            const { erxLog } = this.props;
            let erxRes = (_a = (erxLog || [])) === null || _a === void 0 ? void 0 : _a.filter((item) => item.outgoing === 0); //B-096.2
            const content = (responses !== null && responses !== void 0 ? responses : []).map((response, i) => {
                var _a, _b;
                let responseCopy = Object.assign({}, response);
                if (responseCopy.rejectCode) {
                    responseCopy = this.mapRejectionCodes(response);
                }
                return (React.createElement("div", { key: `res-${tag}-${i}`, className: "transaction-details__body--container" },
                    React.createElement("h2", null,
                        tag === "copay" && "Copay ",
                        "Transaction #",
                        i + 1),
                    React.createElement("div", { className: "transaction-details__body--nested-list" },
                        erxLog && (React.createElement("div", { style: { display: "ruby-text" } },
                            React.createElement("span", null,
                                React.createElement("h4", null, "Date & Time")),
                            " ",
                            ((_a = erxRes[i]) === null || _a === void 0 ? void 0 : _a.date) ? (React.createElement("span", null, moment.tz((_b = erxRes[i]) === null || _b === void 0 ? void 0 : _b.date, site.timezone).format("MM/DD/YYYY hh:mm:ss A z"))) : (""))),
                        Object.keys(responseCopy).map(key => (React.createElement("div", { key: Math.random().toString() },
                            React.createElement("strong", null,
                                key.slice(0, 1).toUpperCase() +
                                    key.slice(1).replace(/([a-z])([A-Z])/g, "$1 $2"),
                                ":"),
                            " ",
                            React.createElement("span", { "data-class": "transaction-details__tooltip", "data-place": "right", "data-tip": this.fetchTooltip(key, responseCopy[key]), style: { display: "inline-flex" } }, responseCopy[key])))))));
            });
            return content;
        };
        /** Takes Response object and creates human readable errors if rejection codes are found. */
        this.mapRejectionCodes = (response) => {
            const rejectionCodes = response.rejectCode.split(" ");
            rejectionCodes.forEach((code) => {
                const errorProperty = `${code} Error Message `;
                const errorMessage = errors_1.NCPDP_ERROR_CODE_MAP[code];
                response[errorProperty] = errorMessage;
            });
            return response;
        };
        this.recursiveMap = (request, depth = 0, isPrice = false) => Object.keys(request).map(key => {
            if (typeof request[key] === "string") {
                return (React.createElement("div", { key: Math.random().toString() },
                    React.createElement("strong", null, key.slice(0, 1).toUpperCase() +
                        key.slice(1).replace(/([a-z])([A-Z])/g, "$1 $2")),
                    ":",
                    " ",
                    React.createElement("span", { "data-class": "transaction-details__tooltip", "data-place": "right", "data-tip": this.fetchTooltip(key, request[key]), style: { display: "inline-flex" } }, isPrice ? this.toPrice(request[key], key) : request[key])));
            }
            return (React.createElement("div", { key: Math.random().toString() },
                React.createElement("h3", { style: {
                        fontSize: `${Math.max(16 - depth * 2, 13)}px`
                    } }, key.slice(0, 1).toUpperCase() +
                    key.slice(1).replace(/([a-z])([A-Z])/g, "$1 $2")),
                React.createElement("div", { className: "transaction-details__body--nested-list", key: Math.random().toString() }, Array.isArray(mobx_1.toJS(request[key]))
                    ? request[key].map((child) => this.recursiveMap(child, depth + 1, key.toLowerCase() === "pricing"))
                    : this.recursiveMap(request[key], depth + 1, key.toLowerCase() === "pricing"))));
        });
        this.toPrice = (value, key) => {
            if (key === "basisCostDetermination")
                return value;
            const regEx = /^(\d*)([\{ABCDEFGHI])$/;
            const cents = value.replace(regEx, (match, p1, p2) => `${p1}${erxDelimiterMap[p2]}`);
            return `$${(Number(cents) / 100).toFixed(2)}`;
        };
        this.fetchTooltip = (key, value) => {
            try {
                return store_1.ordersStore.erxDataFieldMap[key][value];
            }
            catch (_a) {
                return "";
            }
        };
        this.handleCancelClick = () => this.props.onCancel();
        this.generatePdf = (claim) => async () => _1.transactionDetailsPdf(claim);
        ReactTooltip.rebuild();
    }
    render() {
        var _a, _b, _c, _d;
        const { claim } = this.props;
        const { order } = claim; // C-127.2
        const { site } = order; // C-127.2
        // C-127.2
        const copayRequestMap = this.mapRequests(site, (_b = (_a = claim.copay) === null || _a === void 0 ? void 0 : _a.requests) !== null && _b !== void 0 ? _b : [], "copay");
        // C-127.2
        const copayResponseMap = this.mapResponses(site, (_d = (_c = claim.copay) === null || _c === void 0 ? void 0 : _c.responses) !== null && _d !== void 0 ? _d : [], "copay");
        const requestMap = this.mapRequests(site, claim.requests, "claim"); // C-127.2
        const responseMap = this.mapResponses(site, claim.responses, "claim"); // C-127.2
        return (React.createElement("div", { className: "transaction-details" },
            React.createElement("div", { className: "transaction-details__background", onClick: this.handleCancelClick }),
            React.createElement("div", { className: "transaction-details__body", style: { position: "relative" } },
                React.createElement("div", { style: {
                        position: "absolute",
                        right: "16px",
                        top: "16px"
                    } },
                    React.createElement(material_ui_1.Button, { onClick: this.generatePdf(claim), variant: "raised", color: "secondary", style: { margin: "0 8px" } }, "Export To PDF"),
                    React.createElement(material_ui_1.Button, { onClick: this.handleCancelClick, variant: "raised", style: { margin: "0 8px" } }, "Close")),
                React.createElement("div", { className: "transaction-details__body--collection" },
                    React.createElement("h1", { style: { margin: 0 } }, "Requests"),
                    React.createElement("div", { className: "transaction-details__body--group" },
                        requestMap,
                        React.createElement("br", null),
                        copayRequestMap)),
                React.createElement("div", { className: "transaction-details__body--collection" },
                    React.createElement("h1", { style: { margin: 0 } }, "Responses"),
                    React.createElement("div", { className: "transaction-details__body--group" },
                        responseMap,
                        React.createElement("br", null),
                        copayResponseMap))),
            React.createElement(ReactTooltip, { effect: "solid", place: "left" })));
    }
};
TransactionDetails = __decorate([
    mobx_react_1.observer
], TransactionDetails);
exports.TransactionDetails = TransactionDetails;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/order-claims/transaction-details/transaction-details.tsx
// module id = 3757
// module chunks = 0